export enum BusinessReferenceType {
    Banking = 1,
    PrimarySupplier = 2,
    Trade = 3,
}
